export enum CurrentLocation {
  AbuDhabi = 'auh',
  Dubai = 'dxb',
  Sharjah = 'shj',
  Ajman = 'ajm',
  UmmAlQuwain = 'uaq',
  RasAlKhaimah = 'rak',
  Fujairah = 'fuj'
}
